/* No analytics, network calls, storage, or customer-data logging. */
(() => {
  if (customElements.get('danu-personalization')) return;
  class DanuPersonalization extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('change', () => this.syncTimes());
      this.addEventListener('input', event => {
        if (event.target instanceof HTMLInputElement) event.target.setCustomValidity('');
      });
      this.syncTimes();
      const form = this.closest('form');
      if (form) form.dataset.danuPersonalized = 'true';
    }
    syncTimes() {
      this.querySelectorAll('fieldset').forEach(group => {
        const status = group.querySelector('[data-danu-time-status]');
        const time = group.querySelector('[data-danu-time]');
        if (!status || !time) return;
        const unknown = status.value === 'Unknown';
        time.disabled = unknown;
        time.required = !!status.value && !unknown;
        if (unknown) time.value = '';
      });
    }
    validate() {
      this.syncTimes();
      const error = this.querySelector('[role="alert"].danu-personalization__error');
      if (this.dataset.configured !== 'true') {
        error.textContent = 'This product is not ready for personalized orders.';
        error.hidden = false;
        return false;
      }
      this.querySelectorAll('input[type="text"][required]').forEach(input => {
        input.setCustomValidity(input.value.trim() ? '' : 'Please complete this field.');
      });
      const fields = [...this.querySelectorAll('input,select')];
      const invalid = fields.find(field => !field.disabled && !field.checkValidity());
      error.hidden = !invalid;
      if (invalid) {
        error.textContent = 'Please complete the required personalization details before adding this item.';
        invalid.reportValidity();
        invalid.focus();
        return false;
      }
      return true;
    }
  }
  customElements.define('danu-personalization', DanuPersonalization);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const intake = form.querySelector('danu-personalization');
    if (intake && !intake.validate()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
